import vars from '../../helpers';

let $feedback = $('.feedback');
let $feedbackBtn = $('.js-feedback');

$feedbackBtn.on('click', (e) => {
	e.preventDefault();

	$feedback.fadeToggle(400);
	vars.$body.toggleClass('no-scroll');
});
